__turbopack_context__.v({
  "arrow": "QeIV_G_arrow",
  "checksum": "QeIV_G_checksum",
  "column": "QeIV_G_column",
  "delete": "QeIV_G_delete",
  "download": "QeIV_G_download",
  "downloadWidth": "QeIV_G_downloadWidth",
  "earlyAccess": "QeIV_G_earlyAccess",
  "filter": "QeIV_G_filter",
  "hidden": "QeIV_G_hidden",
  "latest": "QeIV_G_latest",
  "row": "QeIV_G_row",
  "semeruLink": "QeIV_G_semeruLink",
  "semeruParagraph": "QeIV_G_semeruParagraph",
  "tableDownload": "QeIV_G_tableDownload",
  "tdDownload": "QeIV_G_tdDownload",
  "tdDownloadBottom": "QeIV_G_tdDownloadBottom",
  "tdRuntime": "QeIV_G_tdRuntime",
  "version": "QeIV_G_version",
  "wrap": "QeIV_G_wrap",
});
